// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__hPywG","cardOuter":"Card_cardOuter__x3ZTW","image":"Card_image__WAh5N","hardMode":"Card_hardMode__iA6oc"};